import { number, route, string } from "react-router-typesafe-routes";

export const routes = route({
  children: {
    index: route({
      path: "",
    }),
    login: route({
      path: "login",
      children: {
        index: route({
          path: "",
        }),
        authenticate: route({
          path: "authenticate",
        }),
        invitation: route({
          path: "invitation",
        }),
        organizations: route({
          path: "organizations",
        }),
        createOrganization: route({
          path: "organizations/create",
        }),
        emailRequest: route({
          path: "email-request",
        }),
      },
    }),
    portal: route({
      path: "portal",
      children: {
        gettingStarted: route({
          path: "getting-started",
          children: {
            index: route({
              path: "",
            }),
            createClientManually: route({
              path: "create-client-manually",
            }),
          },
        }),
        dashboard: route({
          path: "dashboard",
          children: {
            index: route({
              path: "",
            }),
            generateReport: route({
              path: "generate-report",
            }),
          },
        }),
        profile: route({
          path: "profile",
        }),
        users: route({
          path: "users",
          children: {
            index: route({
              path: "",
            }),
            create: route({
              path: "create",
            }),
            user: route({
              path: ":userId",
            }),
          },
        }),
        notifications: route({
          path: "notifications",
        }),
        applications: route({
          path: "applications",
        }),
        integrations: route({
          path: "integrations",
          children: {
            index: route({
              path: "",
            }),
            microsoftPartnerCenter: route({
              path: "microsoft-partner-center",
            }),
          },
        }),
        administration: route({
          path: "administration",
          children: {
            index: route({
              path: "",
            }),
            applications: route({
              path: "applications",
            }),
            organizations: route({
              path: "organizations",
            }),
          },
        }),
        clients: route({
          path: "clients",
          searchParams: {
            page: number(),
          },
          children: {
            columnSettings: route({
              path: "column-settings",
            }),
            create: route({
              path: "create",
            }),
            client: route({
              path: ":clientId",
              children: {
                dashboard: route({
                  path: "dashboard",
                  children: {
                    applicationUsageByUsers: route({
                      path: "application-usage-by-users",
                      searchParams: {
                        date: string(),
                      },
                    }),
                    extensionInstallation: route({
                      path: "extension-installation",
                    }),
                  },
                }),
                record: route({
                  path: "record",
                }),
                applications: route({
                  path: "applications",
                  children: {
                    index: route({
                      path: "",
                    }),
                    create: route({
                      path: "create",
                    }),
                    application: route({
                      path: ":applicationId",
                      children: {
                        dashboard: route({
                          path: "dashboard",
                        }),
                        record: route({
                          path: "record",
                        }),
                        users: route({
                          path: "users",
                        }),
                      },
                    }),
                  },
                }),
                notifications: route({
                  path: "notifications",
                }),
                clientEmployees: route({
                  path: "employees",
                  children: {
                    index: route({
                      path: "",
                    }),
                    create: route({
                      path: "create",
                    }),
                    clientEmployee: route({
                      path: ":clientEmployeeId",
                      children: {
                        dashboard: route({
                          path: "dashboard",
                        }),
                record: route({
                  path: "record",
                }),
                fileUploads: route({
                  path: "file-uploads",
                }),
              },
                    }),
                  },
                }),
              },
            }),
          },
        }),
      },
    }),
    notFound: route({
      path: "*",
    }),
  },
});
